<div class="d-inline-block">
    <button [ngClass]="buttonClass"
            class="btn btn-outline-primary"
            (click)="op.toggle($event)">
        <fa-icon [icon]="['far', 'question-circle']"
                 class="d-inline-block d-md-none d-xl-inline-block mr-xl-2"></fa-icon>
        <span class="d-none d-md-inline-block">{{ 'common.learn-more' | translate }}</span>
        <fa-icon [icon]="['far', 'chevron-down']" class="ml-1"></fa-icon>
    </button>
</div>

<p-overlayPanel #op>
    <ul class="list-group list-group-flush" style="min-width: 200px;">
        <button
            class="list-group-item list-group-item-action"
            (click)="onShowTutorialVideo()" *ngIf="vimeoVideoId">{{ 'common.tutorial-video' | translate }}
        </button>
        <a class="list-group-item list-group-item-action" *ngIf="documentationUrl" [href]="documentationUrl" target="_blank">{{ 'common.how-to-article' | translate }}</a>
    </ul>
</p-overlayPanel>
